import { useMemo, useState } from 'react'

import { useParams } from 'react-router-dom'

import {
  GenreWithCurators,
  useGetCampaignGenresQuery,
} from 'src/Redux/spotifyCampaignGenresApi'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { useGenresAndLanguagesAnalytics } from 'src/Hooks/useGenresAndLanguagesAnalytics'
import { useSpotifyCampaignStatus } from 'src/Redux/spotifyCampaignStatusApi'

type UseSelectedGenresReturnType = {
  selectedGenres: GenreWithCurators[]
  onSetSelectedGenres: (genre: GenreWithCurators) => void
}
export const useSelectedGenres = (): UseSelectedGenresReturnType => {
  const { handlePopupGenreAddedEvent } = useGenresAndLanguagesAnalytics()
  const { campaignDetails } = useSpotifyCampaignStatus()
  const { number } = useParams<{ number: string }>()
  const { data, isSuccess } = useGetCampaignGenresQuery(number || '', {
    skip: !number,
  })

  const derivedGenres = useMemo(() => {
    if (!campaignDetails?.genres?.length || !isSuccess || !data?.allGenres) {
      return []
    }
    return data.allGenres.filter((genre) =>
      campaignDetails.genres?.some((item) => item.id === genre.id),
    )
  }, [campaignDetails, isSuccess, data])

  const [localSelectedGenres, setLocalSelectedGenres] = useState<
    GenreWithCurators[] | undefined
  >()

  const selectedGenres = localSelectedGenres ?? derivedGenres

  const handleSelectedGenres = (genre: GenreWithCurators): void => {
    setLocalSelectedGenres((prev) => {
      const current = prev ?? derivedGenres
      const isGenreSelected = current.some((item) => item.id === genre.id)
      if (isGenreSelected) {
        return current.filter((item) => item.id !== genre.id)
      }
      handlePopupGenreAddedEvent({
        platformName: CampaignPlatformTypeEnum.SPOTIFY,
        genreId: genre.id,
        genreName: genre.genreName,
      })
      return [...current, genre]
    })
  }

  return { selectedGenres, onSetSelectedGenres: handleSelectedGenres }
}
